<!-- PROFILE PAGE -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 visible" id="profile_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <img src="../../../assets/img/profile.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3">
                <h5 class="card-title text-light font-weight-bold text-center mt-3"> PROFILE</h5>
                <p class="card-text text-center">We will send you a one time password on this mobile number</p>
                <form class="form_profile">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" placeholder="Enter your name" type="text" [(ngModel)]="name" name="name" required>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" placeholder="Enter your email" type="text" [(ngModel)]="email" name="email" required>
                    </div>


                    <div>
                        <button type="button" class="btn btn-danger w-100 profile_btn" (click)="profile()">NEXT</button>
                    </div>

                    <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
                </form>
            </div>
        </div>
    </div>
</div>


<!-- ACTIVATION SECTION -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 hidden" id="activation_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2 d-flex">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                    <img src="../../../assets/img/profile.svg" alt="profile" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <img src="../../../assets/img/Vector.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3">
                <h5 class="card-title text-light font-weight-bold text-center mt-3"> ACTIVATION</h5>
                <p class="card-text text-center mb-0"> Your Ohm device works like a hotspot. Select your Ohm device</p>
                <p class="card-text text-center">Enter password to activate it.</p>
                <form class="form_activation">
                    <select name="cars" class="custom-select mb-3">
                        <option selected>Choose your Ohm device</option>
                        <option value="device1">device1</option>

                    </select>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="password" class="form-control" placeholder="Enter password" type="text" [(ngModel)]="password" name="password" required>
                    </div>


                    <div>
                        <button type="button" class="btn btn-danger w-100 activation_btn" (click)="activation()">NEXT</button>
                    </div>

                    <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
                </form>
            </div>
        </div>
    </div>
</div>


<!-- PAIRING -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 hidden" id="pairing_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2 d-flex">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                    <img src="../../../assets/img/profile.svg" alt="profile" class="img-fluid">
                    <img src="../../../assets/img/Vector.svg" alt="Vector" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <img src="../../../assets/img/pair.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3">
                <h5 class="card-title text-light font-weight-bold text-center mt-3">PAIRING</h5>
                <p class="card-text text-center mb-0"> Your Ohm device works like a hotspot. Select your Ohm device</p>
                <p class="card-text text-center">Enter password to activate it.</p>
                <form class="form_activation">
                    <select name="cars" class="custom-select mb-3">
                        <option selected>Choose your Ohm device</option>
                        <option value="device1">device1</option>

                    </select>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="password" class="form-control" placeholder="Enter password" type="text" [(ngModel)]="password" name="password" required>
                    </div>


                    <div>
                        <button type="button" class="btn btn-danger w-100 activation_btn" (click)="pairing()">NEXT</button>
                    </div>

                    <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
                </form>
            </div>
        </div>
    </div>
</div>


<!-- DETAILS -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 hidden" id="details_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2 d-flex">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                    <img src="../../../assets/img/profile.svg" alt="profile" class="img-fluid">
                    <img src="../../../assets/img/Vector.svg" alt="Vector" class="img-fluid">
                    <img src="../../../assets/img/pair.svg" alt="pair" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 80%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <img src="../../../assets/img/details.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3">
                <h5 class="card-title text-light font-weight-bold text-center mt-3">DETAILS</h5>
                <!-- <div class="para_sub row">
                    <div class="col-md-6"> -->
                <p class="card-text text-center mb-0">The more detailed your information is, the better analysis and</p>
                <p class="card-text text-center mb-0">recomendation for you. At Ohm, we value</p>
                <p class="card-text text-center">your privacy. Please read more here.</p>
                <!-- </div> -->

                <!-- </div> -->

                <form class="form_details">
                    <select name="cars" class="custom-select mb-3">
                        <option selected>Choose electricity supplier</option>
                        <option value="device1">device1</option>

                    </select>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" placeholder="Enter Location" type="text" [(ngModel)]="location" name="location" required>
                    </div>
                    <select name="cars" class="custom-select mb-3">
                        <option selected>Select type</option>
                        <option value="device1">device1</option>

                    </select>

                    <div>
                        <button type="button" class="btn btn-danger w-100 activation_btn" (click)="details()">NEXT</button>
                    </div>

                    <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
                </form>
            </div>
        </div>
    </div>
</div>



<!-- DETAILS -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 hidden all_done_section" id="all_done_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2 d-flex">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                    <img src="../../../assets/img/profile.svg" alt="profile" class="img-fluid">
                    <img src="../../../assets/img/Vector.svg" alt="Vector" class="img-fluid">
                    <img src="../../../assets/img/pair.svg" alt="pair" class="img-fluid">
                    <img src="../../../assets/img/details.svg" alt="details" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <h2 class="card-title text-light font-weight-bold text-center mt-5">ALL DONE</h2>

                <img src="../../../assets/img/alldone.svg" alt="alldone" class="img-fluid all_done_img">

                <p class="text-center text-light mt-5">Processing......</p>
            </div>
        </div>
    </div>
</div>